/** 1vw 转换为 px */
const getVwToPx = () => window.innerWidth / 100;

/** 设计稿的 px 换算成 rem */
export const uiPxToRem = (px: number) => `${px / 37.5}rem`;

/** 设计稿的 px 换算成实际 px */
export const uiPxToPx = (px: number, isInit = true) => {
  const vwToPx = getVwToPx();
  const value = (px / 37.5) * vwToPx * 10;
  return isInit ? Math.floor(value) : value;
};
